import { Grid, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useState, useEffect } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getAssociationById } from 'src/shared/services/associationService';
import AssociationPageTabNavigation from '../components/associationPageTabNavigation';
import { AssociationResponse } from '../models/associationResponse';

export const MyAssociationPage = () => {
  const { t } = useTranslation(['common']);
  const [, setLoading] = useState<boolean>(false);
  const { currentUser } = useGlobals();

  const isMounted = useIsMounted();

  const [association, setAssociation] = useState<AssociationResponse>();

  const currentAssociationId = `${currentUser?.associations[0].localAss_id}`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getAssociationById(currentAssociationId);
        if (isMounted()) {
          setAssociation(result.data);
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      } finally {
        if (isMounted()) setLoading(false);
      }
    };
    if (currentUser && currentAssociationId) {
      fetchData();
    }
  }, [isMounted, currentUser, currentAssociationId]);

  if (!currentUser) return null;

  const pageTabs: SelectableItem[] = [
    {
      label: t('common:organization.pageTabs.form'),
      value: `${RoutesEnum.OrganizationMyAssociation}`,
    },
    {
      label: t('common:organization.pageTabs.fee'),
      value: `${RoutesEnum.OrganizationMyAssociation}/avgift`,
    },
    {
      label: t('common:organization.pageTabs.board'),
      value: `${RoutesEnum.OrganizationMyAssociation}/styrelse`,
    },
    {
      label: t('common:organization.pageTabs.elected'),
      value: `${RoutesEnum.OrganizationMyAssociation}/fortroendevalda`,
    },
    {
      label: t('common:organization.pageTabs.users'),
      value: `${RoutesEnum.OrganizationMyAssociation}/users`,
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MainContentHeader title={association?.localAss ?? ''} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <AssociationPageTabNavigation tabs={pageTabs} />
          <Outlet />
        </Paper>
      </Grid>
    </Grid>
  );
};
